import React from "react";
import "@/App.css";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div translate="no" style={{ padding: 40, fontFamily: 'monospace', color: '#DC2626', background: '#FEF2F2', minHeight: '100vh' }}>
          <h2>Errore applicazione</h2>
          <pre style={{ whiteSpace: 'pre-wrap', fontSize: 13 }}>{this.state.error?.message}</pre>
          <pre style={{ whiteSpace: 'pre-wrap', fontSize: 11, color: '#6B7280' }}>{this.state.error?.stack}</pre>
          <button onClick={() => window.location.reload()} style={{ marginTop: 16, padding: '8px 16px', cursor: 'pointer' }}>Ricarica</button>
          <p style={{ marginTop: 24, fontSize: 12, color: '#6B7280' }}>
            Se il problema persiste, prova ad aprire la pagina in modalità privata o disabilita la traduzione automatica del browser.
          </p>
        </div>
      );
    }
    return this.props.children;
  }
}
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { LanguageProvider } from "./contexts/LanguageContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import LoginPage from "./pages/auth/LoginPage";
import RegisterPage from "./pages/auth/RegisterPage";
import TrialSignupPage from "./pages/auth/TrialSignupPage";
import UpgradePage from "./pages/billing/UpgradePage";
import ForgotPasswordPage from "./pages/auth/ForgotPasswordPage";
import ResetPasswordPage from "./pages/auth/ResetPasswordPage";
import NotFoundPage from "./pages/NotFoundPage";
import DashboardPage from "./pages/dashboard/DashboardPage";
import TicketsPage from "./pages/tickets/TicketsPage";
import TicketDetailPage from "./pages/tickets/TicketDetailPage";
import TechniciansPage from "./pages/technicians/TechniciansPage";
import CallsPage from "./pages/calls/CallsPage";
import AIChatPage from "./pages/ai/AIChatPage";
import VoiceCallWidget from "./pages/voice/VoiceCallWidget";
import PublicSupportPage from "./pages/public/PublicSupportPage";
import PublicTicketReplyPage from "./pages/public/PublicTicketReplyPage";
import SuperAdminPage from "./pages/admin/SuperAdminPage";
import LandingPage from "./pages/public/LandingPage";
import AssetsPage from "./pages/assets/AssetsPage";
import KBPage from "./pages/kb/KBPage";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <ErrorBoundary>
    <LanguageProvider>
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/home" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/start" element={<TrialSignupPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/support" element={<PublicSupportPage />} />
          <Route path="/support/:companySlug" element={<PublicSupportPage />} />
          <Route path="/ticket/reply/:ticketId" element={<PublicTicketReplyPage />} />
          
          {/* Protected Routes */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout>
                  <DashboardPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/tickets"
            element={
              <ProtectedRoute>
                <Layout>
                  <TicketsPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/tickets/:id"
            element={
              <ProtectedRoute>
                <Layout>
                  <TicketDetailPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/assets"
            element={
              <ProtectedRoute>
                <Layout>
                  <AssetsPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/kb"
            element={
              <ProtectedRoute>
                <Layout>
                  <KBPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/technicians"
            element={
              <ProtectedRoute>
                <Layout>
                  <TechniciansPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/calls"
            element={
              <ProtectedRoute>
                <Layout>
                  <CallsPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/ai-chat"
            element={
              <ProtectedRoute>
                <Layout>
                  <AIChatPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/voice-call"
            element={
              <ProtectedRoute>
                <Layout>
                  <VoiceCallWidget />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/upgrade"
            element={
              <ProtectedRoute>
                <Layout>
                  <UpgradePage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <Layout>
                  <SuperAdminPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          
          {/* 404 - Not Found */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </AuthProvider>
    </LanguageProvider>
    </ErrorBoundary>
  );
}

export default App;
